import { j as i, c as g } from "../../utils-BdNIfrGQ.js";
import * as u from "react";
import { c as I } from "../../index-UQQE3dtT.js";
import { P as f } from "../../index-oiSd2zY3.js";
import { c as R } from "../../index-Di82Y7n3.js";
import { n as V } from "../../normalize-spacing-DY0KSpr_.js";
var c = "Progress", d = 100, [j] = I(c), [E, _] = j(c), v = u.forwardRef(
  (r, a) => {
    const {
      __scopeProgress: o,
      value: s = null,
      max: e,
      getValueLabel: w = M,
      ...y
    } = r;
    (e || e === 0) && !m(e) && console.error(A(`${e}`, "Progress"));
    const t = m(e) ? e : d;
    s !== null && !p(s, t) && console.error(S(`${s}`, "Progress"));
    const n = p(s, t) ? s : null, $ = l(n) ? w(n, t) : void 0;
    return /* @__PURE__ */ i.jsx(E, { scope: o, value: n, max: t, children: /* @__PURE__ */ i.jsx(
      f.div,
      {
        "aria-valuemax": t,
        "aria-valuemin": 0,
        "aria-valuenow": l(n) ? n : void 0,
        "aria-valuetext": $,
        role: "progressbar",
        "data-state": N(n, t),
        "data-value": n ?? void 0,
        "data-max": t,
        ...y,
        ref: a
      }
    ) });
  }
);
v.displayName = c;
var x = "ProgressIndicator", P = u.forwardRef(
  (r, a) => {
    const { __scopeProgress: o, ...s } = r, e = _(x, o);
    return /* @__PURE__ */ i.jsx(
      f.div,
      {
        "data-state": N(e.value, e.max),
        "data-value": e.value ?? void 0,
        "data-max": e.max,
        ...s,
        ref: a
      }
    );
  }
);
P.displayName = x;
function M(r, a) {
  return `${Math.round(r / a * 100)}%`;
}
function N(r, a) {
  return r == null ? "indeterminate" : r === a ? "complete" : "loading";
}
function l(r) {
  return typeof r == "number";
}
function m(r) {
  return l(r) && !isNaN(r) && r > 0;
}
function p(r, a) {
  return l(r) && !isNaN(r) && r <= a && r >= 0;
}
function A(r, a) {
  return `Invalid prop \`max\` of value \`${r}\` supplied to \`${a}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${d}\`.`;
}
function S(r, a) {
  return `Invalid prop \`value\` of value \`${r}\` supplied to \`${a}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${d} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var b = v, k = P;
const h = u.forwardRef(({ className: r, value: a, ...o }, s) => /* @__PURE__ */ i.jsx(
  b,
  {
    ref: s,
    className: g("relative w-full overflow-hidden", r),
    ...o,
    children: /* @__PURE__ */ i.jsx(
      k,
      {
        className: "h-full w-full flex-1 transition-all",
        style: { transform: `translateX(-${100 - (a || 0)}%)` }
      }
    )
  }
));
h.displayName = b.displayName;
const C = R("shadow", {
  variants: {
    color: {
      primary: "bg-primary-light/40 text-primary-dark",
      success: "bg-success-light/40 text-success-dark",
      warning: "bg-warning-light/40 text-warning-dark",
      info: "bg-info-light/40 text-info-dark"
    }
  },
  defaultVariants: {
    color: "success"
  },
  compoundVariants: [
    {
      color: "primary",
      className: "*:bg-primary"
    },
    {
      color: "success",
      className: "*:bg-success"
    },
    {
      color: "info",
      className: "*:bg-info"
    },
    {
      color: "warning",
      className: "*:bg-warning"
    }
  ]
}), D = ({
  color: r = "success",
  value: a,
  spacing: o
}) => /* @__PURE__ */ i.jsx(
  h,
  {
    value: a,
    className: g(C({ color: r }), V(o), "h-5 rounded-lg")
  }
);
D.displayName = "Progress bar";
export {
  D as default
};
